<!-- src/pages/auth/logout.vue -->
<template>
  <div class="d-flex justify-content-center align-items-center" style="height:60vh">
    <div class="text-center">
      <div class="spinner-border" role="status" aria-hidden="true"></div>
      <p class="mt-3">Saindo... Aguarde.</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/authStore";

const router = useRouter();
const auth = useAuthStore();

onMounted(async () => {
  try {
    if (auth.logout) await auth.logout();
  } catch (e) {
    console.error("Logout falhou:", e);
  } finally {
    router.replace({ name: "login" });
  }
});
</script>
